module.exports = __webpack_public_path__ + "405d9142711d9e2b59b047f4814656ed.pdf";